module.exports = __webpack_public_path__ + "media/images/app/login/logo-46f847d5f2a4c7e87c3d50e3f7b83711.svg";